import React, {useState} from "react";
import { useHistory } from "react-router-dom";
// Redux
import { useDispatch } from "react-redux";
import { getUser, resetIdNotification } from "redux/actions/userActions";
// MUI
import { ADD_WORKER, PUNCH, ROOT } from "navigation/CONSTANTS";
import WorkerView from "./WorkerView";

export const WorkerContainer = ({setMealEndLoader}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  // var callback = function () {
  //   history.push(PUNCH);
  // };
  const getEmployee = (empId, callback) => {
    dispatch(getUser(empId, callback));
  };

  const closeModalIdNotificationMsg = () => {
    dispatch(resetIdNotification());
    history.push(ROOT);
  };
 
  const handleAddWorker = (empId) => {
    dispatch(resetIdNotification());
    history.push(ADD_WORKER,{ empId: empId});
  };
  return <WorkerView 
      getEmployee={getEmployee} closeModalIdNotificationMsg={closeModalIdNotificationMsg} 
      handleAddWorker={handleAddWorker} setMealEndLoader={setMealEndLoader}/>;
};

export default WorkerContainer;
